module.exports = __webpack_public_path__ + "img/yuangongzhaopin.e5bc5106.png";